import type { DocMigration } from "../docMigration";

let count = 0;
function textGlobalParameter(id: string) {
  return {
    entityType: "PARAMETER",
    sortIndex: count++,
    type: "TEXT",
    id,
    name: id[0].toUpperCase() + id.slice(1),
  };
}

const MasterPlanGlobalParameters = {
  builderName: textGlobalParameter("builderName"),
  builderAddress: textGlobalParameter("builderAddress"),
  builderCity: textGlobalParameter("builderCity"),
  builderState: textGlobalParameter("builderState"),
  builderZip: textGlobalParameter("builderZip"),
  builderLogoUrl: textGlobalParameter("builderLogoUrl"),
  masterPlanName: textGlobalParameter("masterPlanName"),
};

const LotSpecificGlobalParameters = {
  ...MasterPlanGlobalParameters,

  communityPlanName: textGlobalParameter("communityPlanName"),
  communityName: textGlobalParameter("communityName"),
  communityGeneralNotes: textGlobalParameter("communityGeneralNotes"),
  communityGovernmentCodeAndStandards: textGlobalParameter("communityGovernmentCodeAndStandards"),
  communityBuildingCodeAnalysisDesignCriteria: textGlobalParameter("communityBuildingCodeAnalysisDesignCriteria"),
  homePlanName: textGlobalParameter("homePlanName"),
  homePlanSetId: textGlobalParameter("homePlanSetId"),
  homePlanStatus: textGlobalParameter("homePlanStatus"),
  customerName: textGlobalParameter("customerName"),
  lotNumber: textGlobalParameter("lotNumber"),
  lotAddress: textGlobalParameter("lotAddress"),
};

const AllGlobalParameters = LotSpecificGlobalParameters;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_323: DocMigration = {
  maxSchemaVersion: "0.0.323",
  description: "Correct incorrect formatting of annotation names including parameters",
  apply(json: any): any {
    const parameterPrefix = "{{";
    const parameterSuffix = "}}";

    const parameters = {
      ...AllGlobalParameters,
      ...json.parameters,
    };

    for (const id in json.annotation) {
      const annotation = json.annotation[id];

      if (annotation.type !== "NOTE") {
        continue;
      }

      if (!annotation.name) {
        continue;
      }

      const paramIds = Object.keys(parameters);

      // Param ids should not be exposed directly in the annotation name
      const paramId = annotation.name.split(" ").find((token) => paramIds.includes(token));

      if (!paramId) {
        continue;
      }

      const parameter = parameters[paramId];

      if (!parameter) {
        continue;
      }

      annotation.name = annotation.name.replace(parameterPrefix, "");
      annotation.name = annotation.name.replace(parameterSuffix, "");
      annotation.name = annotation.name.replace(paramId, parameter.name);
      annotation.name = annotation.name.trim();
    }

    return json;
  },
};

export default migration_0_0_323;
